import React, {PropTypes, Component} from 'react';
const s = require('./app.scss');

class App extends Component {
  static propTypes = {
    BugFixes: PropTypes.element,
    PostsList: PropTypes.element,
    Navigation: PropTypes.element.isRequired,
    Subscribe: PropTypes.element,
    Post: PropTypes.element
  }

  componentDidMount() {
    document.getElementsByTagName('body')[0].classList.remove('loading');
  }

  render() {
    const {PostsList, Navigation, BugFixes, Post, Subscribe} = this.props;
    return (
      <main className={s.main}>
        {Navigation}
        {PostsList}
        {Post}
        {BugFixes}
        {Subscribe}
      </main>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./containers/App/App.js